import { render, staticRenderFns } from "./GeneralLocation.vue?vue&type=template&id=b28602f8&scoped=true"
import script from "./GeneralLocation.vue?vue&type=script&lang=js"
export * from "./GeneralLocation.vue?vue&type=script&lang=js"
import style0 from "./GeneralLocation.vue?vue&type=style&index=0&id=b28602f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28602f8",
  null
  
)

export default component.exports